import(/* webpackMode: "eager", webpackExports: ["GoogleAuthPopup"] */ "/vercel/path0/app/components/auth/GoogleAuthPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientStoreBootstrap"] */ "/vercel/path0/app/components/ClientStoreBootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitalsReporter"] */ "/vercel/path0/app/components/WebVitalsReporter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@2.0.1_next@16.2.6_react-dom@19.2.7_react@19.2.7__react@19.2.7__react@19.2.7/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@2.0.0_next@16.2.6_react-dom@19.2.7_react@19.2.7__react@19.2.7__react@19.2.7/node_modules/@vercel/speed-insights/dist/next/index.mjs");
